import { Component, OnInit } from '@angular/core';
import { ActivityEditorBaseComponent } from '../../activity-editor-base/activity-editor-base.component';

@Component({
    selector: 'wm-required-user-activity-editor',
    templateUrl: './required-user-activity-editor.component.html',
    styleUrls: ['./required-user-activity-editor.component.css'],
    standalone: false
})
export class RequiredUserActivityEditorComponent
  extends ActivityEditorBaseComponent
  implements OnInit {
  constructor() {
    super();
  }

  ngOnInit() {}
}
